import { relocateAdgepublicAssetUrl, type CreativePathPair } from "@nexus/contracts";

import { readCachedCreativeUrlSettings } from "@/lib/queries/system-settings.queries";

import type { PersonaTopAd } from "../types/personas.types";

export interface PersonaAdMedia {
  type: "image" | "video";
  thumbnailUrl: string;
  assetUrl: string;
}

const THUMBNAIL_EXTENSION = ".png";

/**
 * Ad thumbnails live alongside assets under `/thumbnails/` as a `.png` — same
 * convention as the overview topic examples (BQ `adge_url` is the canonical asset URL).
 */
export function resolvePersonaAdMedia(ad: PersonaTopAd, paths?: CreativePathPair): PersonaAdMedia {
  const assetUrl = relocateAdgepublicAssetUrl(ad.adgeUrl, paths ?? readCachedCreativeUrlSettings()) ?? ad.adgeUrl;
  const type: PersonaAdMedia["type"] = assetUrl.toLowerCase().endsWith(".mp4") ? "video" : "image";
  const thumbnailUrl = assetUrl.replace("/assets/", "/thumbnails/").replace(/\.[^./]+$/, THUMBNAIL_EXTENSION);
  return { type, thumbnailUrl, assetUrl };
}
